import { inject, Injectable } from '@angular/core';
import { assert, isDefined } from '@sama/js-core';
import { isUndefined } from 'lodash';
import { ObjectState } from '../../../cross-team-shared/annotation/shared/state/object-state';
import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Injectable()
export class AnnotationFilteringService {
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  calculateIsObjectFilteredOut(object: ObjectState) {
    const { objectTransientInfo, scopedObjectId } =
      this.taskWorkspaceStore.state();

    if (isUndefined(object.parentId)) {
      // if there is a scoped object, root objects are filtered out if they are
      // not the scoped object.
      return isDefined(scopedObjectId) && object.index !== scopedObjectId;
    }
    const transientInfo = objectTransientInfo[object.parentId];
    assert(transientInfo, 'objects should always have transient info');
    return object.index !== scopedObjectId && transientInfo.isFilteredOut;
  }

  calculateIsShapeFilteredOut(shape: ShapeState) {
    assert(
      isDefined(shape.parentId),
      'shapes in object enabled projects should always have an object id',
    );

    const { objectTransientInfo, scopedObjectId } =
      this.taskWorkspaceStore.state();
    const transientInfo = objectTransientInfo[shape.parentId];
    assert(transientInfo, 'objects should always have transient info');
    return transientInfo.isFilteredOut && shape.parentId !== scopedObjectId;
  }
}
